/* tp-cartfx (16.10.2026): experienta la adaugarea in cos.
   - poza produsului zboara din pagina in linia noua din sertar (top layer prin popover, deci apare deasupra sertarului)
   - banner "Adaugat in cos" cu bifa desenata + livrarea estimata (preluata din pagina de produs)
   - lumina in culoarea dominanta a pozei, confetti scurt, vibratie pe telefon, insigna cosului "sare" la inchidere
   - telefon: swipe in jos pe manerul foii de jos inchide cosul
   Oprire: ?tps=0 sau scoate include-ul din layout/theme.liquid. Nu modifica logica de cos din tp-app-ui.js (doar asculta evenimente). */
(function () {
  'use strict';
  try {
    if (/[?&]tps=0(&|$)/.test(location.search)) return;
    var dlg = document.getElementById('tp-cart-dialog');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var root = document.documentElement;
    root.classList.add('tpfx-on');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var canPop = typeof HTMLElement.prototype.showPopover === 'function';
    var pending = null;
    var BRAND = [[255, 122, 48], [230, 57, 80], [245, 179, 1]];

    function isReduced() { return !!(reduce && reduce.matches); }
    function isAddForm(f) {
      if (!(f instanceof HTMLFormElement)) return false;
      try { var u = new URL(f.action, location.href); return u.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname); } catch (e) { return false; }
    }
    function rect(el) { var r = el.getBoundingClientRect(); return { left: r.left, top: r.top, width: r.width, height: r.height }; }

    /* poza sursa: slide-ul vizibil din galeria produsului / poza cardului / poza completarii */
    function sourceImage(form) {
      var pdp = form.closest('[data-tp-product]');
      if (pdp) {
        var g = pdp.querySelector('[data-tp-pdp-gallery]');
        if (g) {
          var gr = g.getBoundingClientRect(), best = null, bv = 0;
          g.querySelectorAll('.tp-pdp-slide img').forEach(function (im) {
            var r = im.getBoundingClientRect(), w = Math.max(0, Math.min(r.right, gr.right) - Math.max(r.left, gr.left));
            if (w > bv) { bv = w; best = im; }
          });
          if (best) return best;
        }
      }
      var box = form.closest('.tp-app-card, .tp-upsell, .card-wrapper, .tp-acc-offer .tp-upsell') || form.parentElement;
      return box ? box.querySelector('img') : null;
    }

    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!isAddForm(f)) return;
      var idEl = f.querySelector('[name="id"]');
      var variant = idEl && idEl.value ? String(idEl.value) : '';
      if (!variant && f.elements && f.elements.id) variant = String(f.elements.id.value || '');
      var img = null, r = null, src = '';
      try { img = sourceImage(f); } catch (er) {}
      if (img) {
        r = rect(img);
        src = img.currentSrc || img.src || '';
        if (r.width < 8 || r.height < 8 || r.top + r.height < 0 || r.top > window.innerHeight) { r = null; }
      }
      var eta = '';
      var etaEl = document.querySelector('.tp-de__primary b');
      if (etaEl && f.closest('[data-tp-product]')) eta = (etaEl.textContent || '').trim();
      try { if (eta) sessionStorage.setItem('tp_eta', eta); } catch (er) {}
      pending = { t: performance.now(), variant: variant, rect: r, src: src, eta: eta, nat: img ? [img.naturalWidth || 1, img.naturalHeight || 1] : [1, 1] };
    }, true);

    document.addEventListener('tp:cart-updated', function () {
      if (!pending || performance.now() - pending.t > 12000) return;
      var p = pending; pending = null;
      afterAdd(p).catch(function () {});
    });

    function findLine(variant) {
      if (!variant) return null;
      var btn = dlg.querySelector('[data-tp-line^="' + variant + ':"]');
      return btn ? btn.closest('.tp-cart-item') : null;
    }

    /* culoarea dominanta a pozei (mica analiza pe canvas; CDN-ul Shopify permite CORS) */
    function dominant(src) {
      return new Promise(function (resolve) {
        if (!src) return resolve(null);
        var im = new Image(); im.crossOrigin = 'anonymous';
        var done = false; var to = setTimeout(function () { if (!done) { done = true; resolve(null); } }, 1500);
        im.onload = function () {
          if (done) return; done = true; clearTimeout(to);
          try {
            var c = document.createElement('canvas'), n = 28; c.width = n; c.height = n;
            var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, n, n);
            var d = x.getImageData(0, 0, n, n).data, R = 0, G = 0, B = 0, W = 0;
            for (var i = 0; i < d.length; i += 4) {
              var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
              if (a < 200) continue;
              var mx = Math.max(r, g, b), mn = Math.min(r, g, b), sat = mx ? (mx - mn) / mx : 0;
              if (mx > 235 && sat < .12) continue;      /* fundal alb */
              var w = .15 + sat * sat * 3 + (mx < 60 ? 0 : .1);
              R += r * w; G += g * w; B += b * w; W += w;
            }
            if (W < 1) return resolve(null);
            var rr = R / W, gg = G / W, bb = B / W, lum = .2126 * rr + .7152 * gg + .0722 * bb;
            if (lum < 70) { var k = 70 / Math.max(lum, 1); rr = Math.min(255, rr * k); gg = Math.min(255, gg * k); bb = Math.min(255, bb * k); }
            resolve([Math.round(rr), Math.round(gg), Math.round(bb)]);
          } catch (e) { resolve(null); }
        };
        im.onerror = function () { if (!done) { done = true; clearTimeout(to); resolve(null); } };
        im.src = src;
      });
    }

    function settle() {
      var anims = [];
      try { anims = dlg.getAnimations().map(function (a) { return a.finished.catch(function () {}); }); } catch (e) {}
      return Promise.race([Promise.all(anims), new Promise(function (r) { setTimeout(r, 750); })]);
    }

    function banner(p) {
      var slot = dlg.querySelector('[data-tpfx-slot]');
      if (!slot) return;
      slot.classList.remove('is-done');
      slot.innerHTML = '<div class="tpfx-banner" role="status"><span class="tpfx-check"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 12.6l3.6 3.6 7.4-7.8"/></svg></span>' +
        '<div><strong>Adăugat în coș</strong><small>' + (p.eta ? '📦 Comanda va ajunge probabil la tine <b>' + p.eta + '</b>' : 'Livrare gratuită în România') + '</small></div></div>';
      clearTimeout(slot._to);
      slot._to = setTimeout(function () { slot.classList.add('is-done'); }, 4800);
    }

    function haptic() { try { if (navigator.vibrate && window.matchMedia('(pointer: coarse)').matches && (!navigator.userActivation || navigator.userActivation.isActive)) navigator.vibrate([14, 40, 10]); } catch (e) {} }

    function fly(p, li) {
      if (!canPop || isReduced() || !p.rect || !p.src || !li) return Promise.resolve();
      var target = li.querySelector('img');
      if (!target) return Promise.resolve();
      return new Promise(function (resolve) {
        try {
          var tr = rect(target);
          if (tr.width < 8) return resolve();
          var ratio = p.nat[0] / p.nat[1] || 1;
          var sw = Math.min(p.rect.width, 190), sh = sw / ratio;
          if (sh > p.rect.height) { sh = p.rect.height; sw = sh * ratio; }
          var sx = p.rect.left + (p.rect.width - sw) / 2, sy = p.rect.top + (p.rect.height - sh) / 2;
          var tw = target.getBoundingClientRect().width, th = target.getBoundingClientRect().height;
          var s = Math.min(tw / sw, th / sh) * .92;
          var dx = (tr.left + tr.width / 2) - (sx + sw / 2), dy = (tr.top + tr.height / 2) - (sy + sh / 2);
          var c = document.createElement('img');
          c.className = 'tpfx-fly'; c.alt = ''; c.setAttribute('popover', 'manual'); c.src = p.src;
          c.style.left = sx + 'px'; c.style.top = sy + 'px'; c.style.width = sw + 'px'; c.style.height = sh + 'px';
          document.body.appendChild(c);
          c.showPopover();
          li.classList.add('tpfx-hide-img');
          var arc = Math.max(40, Math.min(120, Math.abs(dy) * .25));
          var a = c.animate([
            { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
            { transform: 'translate(' + (dx * .45) + 'px,' + (dy * .35 - arc) + 'px) scale(' + (1 + (s - 1) * .45) + ') rotate(-7deg)', opacity: 1, offset: .5 },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ') rotate(0deg)', opacity: 1, offset: 1 }
          ], { duration: 640, easing: 'cubic-bezier(.34,.1,.2,1)', fill: 'forwards' });
          var fin = function () {
            try { c.hidePopover(); } catch (e) {}
            c.remove();
            li.classList.remove('tpfx-hide-img'); li.classList.add('tpfx-landed');
            setTimeout(function () { li.classList.remove('tpfx-landed'); }, 700);
            resolve({ x: tr.left + tr.width / 2, y: tr.top + tr.height / 2 });
          };
          a.onfinish = fin; a.oncancel = fin;
        } catch (e) { li.classList.remove('tpfx-hide-img'); resolve(); }
      });
    }

    function confetti(x, y, rgb) {
      if (!canPop || isReduced()) return;
      try {
        var cv = document.createElement('canvas');
        cv.className = 'tpfx-confetti'; cv.setAttribute('popover', 'manual');
        var W = window.innerWidth, H = window.innerHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
        cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
        document.body.appendChild(cv); cv.showPopover();
        var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
        var cols = BRAND.concat(rgb ? [rgb, rgb] : []).concat([[255, 255, 255]]);
        var parts = [];
        for (var i = 0; i < 34; i++) {
          var ang = Math.random() * Math.PI * 2, sp = 3 + Math.random() * 6;
          parts.push({ x: x, y: y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp - 3.2, r: 2.2 + Math.random() * 3.2, c: cols[i % cols.length], rot: Math.random() * 6, vr: (Math.random() - .5) * .5, sq: Math.random() > .45, life: 1 });
        }
        var t0 = performance.now();
        (function step(now) {
          var t = now - t0; ctx.clearRect(0, 0, W, H); var alive = false;
          parts.forEach(function (q) {
            q.vy += .22; q.vx *= .985; q.x += q.vx; q.y += q.vy; q.rot += q.vr; q.life = Math.max(0, 1 - t / 1100);
            if (q.life > 0) alive = true;
            ctx.save(); ctx.globalAlpha = q.life; ctx.translate(q.x, q.y); ctx.rotate(q.rot); ctx.fillStyle = 'rgb(' + q.c.join(',') + ')';
            if (q.sq) ctx.fillRect(-q.r, -q.r * .6, q.r * 2, q.r * 1.2); else { ctx.beginPath(); ctx.arc(0, 0, q.r * .8, 0, 6.3); ctx.fill(); }
            ctx.restore();
          });
          if (alive && t < 1200) requestAnimationFrame(step); else { try { cv.hidePopover(); } catch (e) {} cv.remove(); }
        })(t0);
      } catch (e) {}
    }

    async function afterAdd(p) {
      var li = findLine(p.variant);
      banner(p);
      var rgbP = dominant(p.src);
      if (li) li.classList.add('tpfx-new');
      var rgb = await rgbP;
      if (rgb) dlg.style.setProperty('--tpfx-rgb', rgb.join(', ')); else dlg.style.removeProperty('--tpfx-rgb');
      root.style.setProperty('--tpfx-rgb', rgb ? rgb.join(', ') : '255, 122, 48');
      await settle();
      if (li && li.scrollIntoView) { try { li.scrollIntoView({ block: 'nearest', behavior: isReduced() ? 'auto' : 'smooth' }); } catch (e) {} }
      var landed = await fly(p, li);
      haptic();
      if (landed) confetti(landed.x, landed.y, rgb);
      else if (li) { var r = rect(li); confetti(r.left + 50, r.top + 50, rgb); }
      if (li) setTimeout(function () { li.classList.add('is-settled'); }, 4200);
      dlg.dataset.tpfxAdded = '1';
    }

    /* la inchidere: insigna cosului "sare" ca sa vezi ca s-a adaugat */
    dlg.addEventListener('close', function () {
      dlg.style.transform = ''; dlg.classList.remove('is-dragging');
      if (dlg.dataset.tpfxAdded !== '1') return;
      delete dlg.dataset.tpfxAdded;
      if (isReduced()) return;
      document.querySelectorAll('[data-tp-cart-count]:not([hidden]), .tp-cart-badge:not([hidden])').forEach(function (n) {
        n.classList.remove('tpfx-bump'); void n.offsetWidth; n.classList.add('tpfx-bump');
        setTimeout(function () { n.classList.remove('tpfx-bump'); }, 800);
      });
    });

    /* telefon: swipe in jos pe maner / antet inchide foaia */
    (function () {
      var sy = 0, dy = 0, t0 = 0, active = false, pid = null;
      var mq = window.matchMedia('(max-width: 767px)');
      dlg.addEventListener('pointerdown', function (e) {
        if (!mq.matches || !dlg.open) return;
        if (!e.target.closest('.tpfx-grab, .tp-cart-header')) return;
        if (e.target.closest('button')) return;
        active = true; pid = e.pointerId; sy = e.clientY; dy = 0; t0 = performance.now();
        dlg.classList.add('is-dragging');
        try { dlg.setPointerCapture(pid); } catch (er) {}
      });
      dlg.addEventListener('pointermove', function (e) {
        if (!active || e.pointerId !== pid) return;
        dy = Math.max(0, e.clientY - sy);
        dlg.style.transform = 'translateY(' + dy + 'px)';
      });
      function end(e) {
        if (!active || (e && e.pointerId !== pid)) return;
        active = false; dlg.classList.remove('is-dragging');
        var v = dy / Math.max(1, performance.now() - t0);
        if (dy > 110 || (v > .55 && dy > 30)) {
          dlg.style.transition = 'transform .22s ease-out'; dlg.style.transform = 'translateY(105%)';
          setTimeout(function () { dlg.style.transition = ''; dlg.close(); dlg.style.transform = ''; }, 210);
        } else {
          dlg.style.transition = 'transform .28s cubic-bezier(.2,1.2,.3,1)'; dlg.style.transform = '';
          setTimeout(function () { dlg.style.transition = ''; }, 300);
        }
        try { dlg.releasePointerCapture(pid); } catch (er) {}
      }
      dlg.addEventListener('pointerup', end); dlg.addEventListener('pointercancel', end);
    })();
  } catch (err) { /* nu stricam pagina niciodata */ }
})();
